import React from 'react'


import '../styles/main.scss'

import { createRoot } from 'react-dom/client'

import LandingPage from './components/pages/LandingPage'

 createRoot(document.getElementById('app')).render(
  React.createElement(LandingPage),
)
